<template>
  <b-tab title="Entradas" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE ENTRADAS DE EQUIPAMENTOS :::::::::::::::::::::::::::: -->
      <b-table
        bordered
        hover
        small
        head-variant="light"
        :per-page="perPage"
        :current-page="currentPage"
        :items="getFilterEntradas(filtro)"
        :fields="fields.entrada"
      >
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="itens(data.item)" v-b-tooltip.hover title="Itens">
              <b-icon icon="diagram3" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="atv-desc-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input
              id="atv-cliente-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Cliente"
              v-model="filtro.cliente"
            />
            <b-form-input
              id="atv-rec-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Quem recebeu"
              v-model="filtro.recebeu"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
            <b-pagination
              class="m-1 ml-2"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="table-equip"
              limit="3"
              size="sm"
            ></b-pagination>
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <entrada-modal ref="editorEntrada" />
      <confirm-modal ref="confirmDelEntrada" :descricao="'Deseja realmente remover a entrada ?'" @executar="executar()" />
      <itens-list-modal ref="entradaItensList" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import Entrada from "@/models/Entrada";
import TableFields from "@/tools/TableFields";
import EntradaModal from "@/components/modals/armazem/EntradaModal";
import EntradaItensListModal from "@/components/modals/armazem/EntradaItensListModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";
import Notificacao from "@/models/Notificacao";

export default {
  name: "EntradaTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: {
        descricao: "",
        cliente: "",
        recebeu: "",
      },
      entrada: new Entrada(0, "Nova Entrada", "", new Date(), "", "", "", ""),
      perPage: 50,
      currentPage: 1,
    };
  },

  components: {
    "entrada-modal": EntradaModal,
    "confirm-modal": ConfirmModal,
    "itens-list-modal": EntradaItensListModal,
  },

  computed: {
    rows() {
      return this.getFilterEntradas(this.filtro).length;
    },
  },

  methods: {
    adicionar() {
      this.entrada = new Entrada(0, "Nova Entrada", "", new Date(), "", "", "", "");
      this.$refs.editorEntrada.call(this.entrada);
    },

    editar(entrada) {
      this.$refs.editorEntrada.call(entrada);
    },

    itens(entrada) {
      this.$refs.entradaItensList.call(entrada);
    },

    deletar(entrada) {
      this.entrada.update(entrada);
      this.$refs.confirmDelEntrada.call();
    },

    executar() {
      this.entradaStore.LISTAR_ENTRADAS(this.entrada.id).then(() => {
        if (this.getEntradaItens.length === 0) {
          this.entradaStore.REMOVER_ENTRADA(this.entrada.id);
        } else {
          this.store.NOTIFICAR(new Notificacao("Existem itens não atendidos na entrada!", "Não Executado!", "danger"));
        }
      });
    },
  },

  setup() {
    const store = useSgcqStore();
    const entradaStore = useEntradaSaidaStore();
    const { getEntradaItens } = storeToRefs(entradaStore);
    const { getFilterEntradas } = storeToRefs(entradaStore);

    return {
      store,
      entradaStore,
      getFilterEntradas,
      getEntradaItens,
    };
  },
};
</script>

<style lang="scss" scoped>
#atv-desc-filter {
  width: 18rem;
}
#atv-cliente-filter {
  width: 14rem;
}
#atv-rec-filter {
  width: 14rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
